import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'sortTable',
})
export class SortTablePipe implements PipeTransform {
	constructor() {}

	transform(table: any[], orderKey: string, args?: any): any {
		if (table && Array.isArray(table)) {
			if (orderKey) {
				return table.sort((a, b) => a[orderKey] - b[orderKey]);
			}
			return table;
		}
		throw new Error('Content provided must be of type Array');
	}
}
